import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const LoanOfferLazy = lazyLoader(
  () => import('./LoanOffer' /* webpackChunkName: "loan-offer" */),
);

const LoanOffer = () => {
  return (
    <Suspense fallback={null}>
      <LoanOfferLazy />
    </Suspense>
  );
};

export default LoanOffer;
